import type { InventoryMatch, InventoryResultsStats } from '@openx/components-core/lib/AiChat/types.ts';
import { useTranslation } from 'react-i18next';
import { MatchResultsCard } from './MatchResultsCard.tsx';

export type InventoryResultsCardProps = {
  matches: InventoryMatch[];
  stats: InventoryResultsStats;
  disabled?: boolean;
};

export const InventoryResultsCard = ({ matches, stats, disabled = false }: InventoryResultsCardProps) => {
  const { t } = useTranslation();

  return (
    <MatchResultsCard
      title={t('Best Inventory Matches')}
      metricLabel={t('Market Requests')}
      disabled={disabled}
      dataTest="inventory-results-card"
      matches={matches.map(match => ({ ...match, metric: match.marketRequests }))}
      stats={[
        { label: t('Relevance'), value: stats.relevance },
        { label: t('Avg CPM'), value: stats.avgCpm },
        { label: t('Viewability'), value: stats.viewability },
        { label: t('Bid Rate'), value: stats.bidRate },
      ]}
    />
  );
};
